import { useEffect, useState } from "react";

import type { Meta, StoryObj } from "@storybook/react";

import type { TextFieldProps } from "@/ui/core";
import { TextField } from "@/ui/core";
import { Box } from "@/ui/layout";

const StoryMeta: Meta<TextFieldProps> = {
  title: "Core/Text Field",
  component: TextField,
  argTypes: {
    hasDynamicHeight: { control: "boolean" },
    hasError: { control: "boolean" },
    isBorderless: { control: "boolean" },
    isDisabled: { control: "boolean" },
    isMultiline: { control: "boolean" },
    isSecureEntry: { control: "boolean" },
    onChange: { action: "Changed" },
    placeholder: { control: "text" },
    value: { control: "text" },
  },
  args: {
    isBorderless: false,
    placeholder: "Placeholder",
    value: "",
  },

  // eslint-disable-next-line no-restricted-syntax -- non-arrow function used here as React FC needed for use of state hook
  render: function Render(args) {
    const [value, setValue] = useState<null | string | undefined>(args.value);

    useEffect(() => {
      setValue(args.value);
    }, [args.value]);

    return (
      <Box width="100%">
        <TextField
          {...args}
          onChange={(newValue) => {
            setValue(newValue);
            args.onChange(newValue);
          }}
          placeholder={args.placeholder}
          value={value}
        />
      </Box>
    );
  },
};

type Story = StoryObj<TextFieldProps>;

const Primary: Story = {};

const Borderless: Story = {
  args: {
    isBorderless: true,
  },
};

const DynamicHeight: Story = {
  args: {
    hasDynamicHeight: true,
    isMultiline: true,
    value:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum",
  },
};

const SecureEntry: Story = {
  args: {
    isSecureEntry: true,
  },
};

const Disabled: Story = {
  args: {
    isDisabled: true,
  },
};

const WithError: Story = {
  args: {
    hasError: true,
    placeholder: "Email address",
  },
};

export { Borderless, Disabled, DynamicHeight, Primary, SecureEntry, WithError };
export default StoryMeta;
